import {useGetVehicleClassesQuery} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {ServiceVehicle} from '../../core/types/ServiceVehicle';
import {Field} from './primitives/Field';

export function VehicleClassSelect() {
  const {data: vehicleClasses} = useGetVehicleClassesQuery();

  const activeVehicleClasses = vehicleClasses?.filter((vc) => vc.isActive) ?? [];

  const vehicleClassOptions =
    activeVehicleClasses.map((vehicleClass) => ({
      value: vehicleClass.vehicleClassId,
      label: vehicleClass.name,
    })) ?? [];

  return (
    <Field<ServiceVehicle, 'choice'>
      type="choice"
      options={vehicleClassOptions}
      name="vehicleClassId"
      label={i18n.t('entity.vehicleClass.labels.vehicleClass')}
      tooltip={i18n.t('entity.vehicleClass.labels.vehicleClassTooltip')}
    />
  );
}
